import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { Layout, Menu, Dropdown, Button, Modal, message } from "antd";
import { UserOutlined, DownOutlined, FormOutlined, StarOutlined } from "@ant-design/icons";
import moment from "moment";
import { logout } from "redux/actions/auth.action";
import { AppContext } from "contexts/AppContext";
import ModalShare from "components/shared/ModalShare";
import { AUTH_URL, DATE_TIME_FORMAT, VIEW_TYPE, SPORT_TYPE, SPORT_ICONS } from "constants/index";
import RunIcon from "assets/icon/RunIcon";
import RideIcon from "assets/icon/RideIcon";
import SwimIcon from "assets/icon/SwimIcon";
import HikeIcon from "assets/icon/HikeIcon";
import TriathlonIcon from "assets/icon/TriathlonIcon";
import HeaderBar from "components/nav/HeaderBar";

const { Header, Footer, Sider, Content } = Layout;

const TopNavbar = ({ setViewAthleteBar = null }) => {
  const history = useHistory();
  const appContext = useContext(AppContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const goto = (path) => {
    redirect(path);
  };
  const redirect = (path) => {
    history.push({
      pathname: path.pathname,
    });
  };

  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.user);

  useEffect(() => {
    if (appContext.selectedAthlete) {
      setViewAthleteBar(true);
    } else {
      setViewAthleteBar(false);
    }
  }, [appContext.selectedAthlete]);

  const menu = (
    <Menu>
      <Menu.Item onClick={() => logOut()}>Logout</Menu.Item>
    </Menu>
  );

  const logOut = () => {
    dispatch(logout());
  };

  const actions = [
    {
      key: "cmdAdd",
      label: <FormOutlined />,
      onClick: () => goto({ pathname: "/main/note" }),
      // onClick: () => alert("cmdAdd"),
    },
    {
      key: "cmdShare",
      label: "Share",
      onClick: () => showModal(),
    },
    {
      key: "cmdSync",
      label: "Sync Strava",
      onClick: () => window.location.replace(AUTH_URL)
    },
  ];

  const showModal = () => {
    if (appContext.selectedNote) {
      if (appContext.isOwner) {
        setSelectedItem(appContext.selectedNote);
        setIsModalOpen(true);
      } else {
        message.error("Only owner can share");
      }
    } else {
      message.error("Select a note first");
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handlePageView = () => {
    if (appContext.pageView === VIEW_TYPE.Week) {
      appContext.setPageView(VIEW_TYPE.Month);
      appContext.setDateRange({startDate: moment().startOf('month'), endDate: moment().endOf('month')});
    }
    else if (appContext.pageView === VIEW_TYPE.Month) {
      appContext.setPageView(VIEW_TYPE.Year);
      appContext.setDateRange({startDate: moment().startOf('year'), endDate: moment().endOf('year')});
    }
    else if (appContext.pageView === VIEW_TYPE.Year) {
      appContext.setPageView(VIEW_TYPE.Week);
      appContext.setDateRange({startDate: moment().startOf('isoWeek'), endDate: moment().endOf('isoWeek')});
    }
    else {
      appContext.setPageView(VIEW_TYPE.Week);
      goto({ pathname: `/` });
    }
  };

  const handleSportView = (sport) => {
    appContext.setSportView(sport);
  };

  return (
    // <Header>
    //   <h1></h1>
    //   <div>
    //     Balance: ${user.wallet}
    //     <Dropdown overlay={menu} placement="bottomRight">
    //       <Button type="text">
    //         <UserOutlined /> {user.username} <DownOutlined />
    //       </Button>
    //     </Dropdown>
    //   </div>
    // </Header>
    <>
      <Header className={ appContext.selectedAthlete ? "athlete-bar" : ""}>
        {/* <Menu
          theme="light"
          mode="horizontal"
          defaultSelectedKeys={["2"]}
          items={actions}
        /> */}
        <div className="nav-panel">
          <a href={AUTH_URL} className="btn btn-primary">Log in</a>
          {/* { appContext.pageView === VIEW_TYPE.Back && <button onClick={handlePageView} className="btn btn-primary">{appContext.pageView}</button> } */}
          <button onClick={() => handleSportView(SPORT_TYPE.Run)} className={appContext.sportView === SPORT_TYPE.Run ? "btn-icon active" : "btn-icon"}><span><RunIcon/></span></button>
          <button onClick={() => handleSportView(SPORT_TYPE.Ride)} className={appContext.sportView === SPORT_TYPE.Ride ? "btn-icon active" : "btn-icon"}><span><RideIcon/></span></button>
          <button onClick={() => handleSportView(SPORT_TYPE.Swim)} className={appContext.sportView === SPORT_TYPE.Swim ? "btn-icon active" : "btn-icon"}><span><SwimIcon/></span></button>
          <button onClick={() => handleSportView(SPORT_TYPE.Hike)} className={appContext.sportView === SPORT_TYPE.Hike ? "btn-icon active" : "btn-icon"}><span><HikeIcon/></span></button>
          <button onClick={() => handleSportView(SPORT_TYPE.All)} className={appContext.sportView === SPORT_TYPE.All ? "btn-icon active" : "btn-icon"}><span><TriathlonIcon/></span></button>
        </div>

        <HeaderBar/>
        {/* <div className="user-panel"><span className="additional-info">{appContext.dateRange.startDate.format(DATE_TIME_FORMAT.DATE)} - {appContext.dateRange.endDate.format(DATE_TIME_FORMAT.DATE)}</span></div> */}
        {/* <Dropdown overlay={menu} placement="bottomRight">
          <Button type="text">
            <UserOutlined /> {user?.username} <DownOutlined />
          </Button>
        </Dropdown> */}
      </Header>
      <ModalShare
        open={isModalOpen}
        onClose={setIsModalOpen}
        noteId={selectedItem}
      />
    </>

    // <Header style={{ display: "flex", alignItems: "center" }}>
    //   <div className="demo-logo" />
    //   <Menu
    //     theme="dark"
    //     mode="horizontal"
    //     defaultSelectedKeys={["2"]}
    //     items={items1}
    //   />
    //   <Dropdown overlay={menu} placement="bottomRight">
    //     <Button type="text">
    //       <UserOutlined /> {user.username} <DownOutlined />
    //     </Button>
    //   </Dropdown>
    // </Header>
  );
};

export default TopNavbar;
